import { type Images } from '@neos/app'
import accountPath from '../../modules/Components/images/Account.svg'
import cartPath from '../../modules/Components/images/Cart.svg'
import darkThemePath from '../../modules/Components/images/DarkTheme.svg'
import dialogTemplatePath from '../../modules/Components/images/DialogTemplate.svg'
import entityPath from '../../modules/Components/images/Entity.svg'
import filterPath from '../../modules/Components/images/Filter.svg'
import heartPath from '../../modules/Components/images/Heart.svg'
import lightThemePath from '../../modules/Components/images/LightTheme.svg'
import lookupPath from '../../modules/Components/images/Lookup.svg'
import textboxPath from '../../modules/Components/images/Textbox.svg'

const images: Images = {
  account: { path: accountPath, colored: false },
  cart: { path: cartPath, colored: false },
  darkTheme: { path: darkThemePath, colored: true },
  dialogTemplate: { path: dialogTemplatePath, colored: true },
  entity: { path: entityPath, colored: true },
  filter: { path: filterPath, colored: true },
  heart: { path: heartPath, colored: false },
  lightTheme: { path: lightThemePath, colored: true },
  lookup: { path: lookupPath, colored: true },
  menu: 'menu',
  textbox: { path: textboxPath, colored: true },
}

export default images